import React, { useMemo } from "react";
import Slider from "rc-slider/lib/Slider";
import range from "lodash/range";
import { MASTER_SEARCH_RADIUS } from "@/misc/constants";

const RadiusSlider = (props) => {
  const radiusSliderMarks = useMemo(() => {
    return range(1, MASTER_SEARCH_RADIUS + 1, 2).reduce((acc, n) => {
      acc[n] = n;
      return acc;
    }, {});
  }, []);
  return (
    <div style={{ padding: "0 10px" }}>
      <Slider
        {...props}
        marks={radiusSliderMarks}
        min={1}
        max={MASTER_SEARCH_RADIUS}
      />
    </div>
  );
};
export default RadiusSlider;
